import React from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderandNavbar from "./HeaderandNavbar";
import { getCookie } from "../../utils/Utility";
import { getBreadcrumbName } from "../constants";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const authenticated = getCookie("authenticated");
  const isPasswordExpired = getCookie("isPasswordExpired") === "true";

  // Remove 'admin' from the path for breadcrumbs
  const pathnames = location.pathname
    .split("/")
    .filter((x) => x && x !== "admin");

  // Check if current page is dashboard (i.e., /admin/dashboard or /admin)
  const isDashboard =
    pathnames.length === 0 ||
    (pathnames.length === 1 && pathnames[0].toLowerCase() === "dashboard");

  // Check if current page is login, register, or reset-password
  const isAuthPage =
    pathnames.length === 1 &&
    ["login", "register", "reset-password"].includes(
      pathnames[0].toLowerCase()
    );

  // Build the route for each breadcrumb (excluding 'admin')
  const getBreadcrumbRoute = (index: number) => {
    // Always start with /admin, then add the rest
    return "/admin/" + pathnames.slice(0, index + 1).join("/");
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <HeaderandNavbar />
        <Box
          component="main"
          sx={
            authenticated && !isPasswordExpired
              ? { flexGrow: 1, p: 3, marginTop: "45px" }
              : { width: "100%", minHeight: "100vh" }
          }
        >
          {!isDashboard && !isAuthPage && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 2,
                p: 2,
                pl: 0,
              }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  color="primary"
                  onClick={() => navigate("/admin/dashboard")}
                  sx={{ cursor: "pointer" }}
                >
                  Dashboard
                </Link>
                {pathnames.map((value, index) => {
                  // Skip the first item if it's 'dashboard' (already shown)
                  if (index === 0 && value.toLowerCase() === "dashboard")
                    return null;
                  const to = getBreadcrumbRoute(index);
                  const isLast = index === pathnames.length - 1;
                  return isLast ? (
                    <Typography color="text.primary" key={to}>
                      {getBreadcrumbName(value)}
                    </Typography>
                  ) : (
                    <Link
                      underline="hover"
                      color="primary"
                      onClick={() => navigate(to)}
                      sx={{ cursor: "pointer" }}
                      key={to}
                    >
                      {getBreadcrumbName(value)}
                    </Link>
                  );
                })}
              </Breadcrumbs>
            </Box>
          )}
          {children}
        </Box>
      </Box>
    </>
  );
};

export default Layout;
